import React from "react";
import clsx from "clsx";
import { Text } from "@merge-api/merge-javascript-shared";
import { APICategory, UnreleasedAPICategory } from "../../../../../../../../models/Entities";
import {
  LIST_GUTTER_CLASS,
  NAME_COLUMN_CLASS,
  ROW_CLASS,
  SIZE_COLUMN_CLASS,
  STATUS_COLUMN_CLASS,
  TYPE_COLUMN_CLASS,
  UPDATED_COLUMN_CLASS,
} from "../constants";

interface Props {
  category: APICategory | UnreleasedAPICategory;
}

const getColumns = (category: APICategory | UnreleasedAPICategory) => {
  if (category === APICategory.filestorage) {
    return [
      { label: "Size", className: SIZE_COLUMN_CLASS },
      { label: "Updated", className: UPDATED_COLUMN_CLASS },
    ];
  }
  if (category === APICategory.chat) {
    return [
      { label: "Type", className: TYPE_COLUMN_CLASS },
      { label: "Updated", className: UPDATED_COLUMN_CLASS },
    ];
  }
  return [
    { label: "Type", className: TYPE_COLUMN_CLASS },
    { label: "Status", className: STATUS_COLUMN_CLASS },
    { label: "Updated", className: UPDATED_COLUMN_CLASS },
  ];
};

const SyncSelectionsHeaderRow = ({ category }: Props) => (
  <div
    role="row"
    className={clsx(ROW_CLASS, LIST_GUTTER_CLASS, "overflow-y-hidden border-y border-gray-10 py-3")}
  >
    <div role="columnheader" className={NAME_COLUMN_CLASS}>
      <Text variant="h6">Name</Text>
    </div>
    {getColumns(category).map(({ label, className }) => (
      <div key={label} role="columnheader" className={className}>
        <Text variant="h6">{label}</Text>
      </div>
    ))}
  </div>
);

export default SyncSelectionsHeaderRow;
